import { render, staticRenderFns } from "./SingularChart.vue?vue&type=template&id=64b55614&scoped=true&"
import script from "./SingularChart.vue?vue&type=script&lang=js&"
export * from "./SingularChart.vue?vue&type=script&lang=js&"
import style0 from "./SingularChart.vue?vue&type=style&index=0&id=64b55614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b55614",
  null
  
)

export default component.exports